const kryginaVideos = [
  {
    id: 1,
    src: "/assets/videos/krygina/1.webm",
    poster: require("./images/krygina/2-1-video-preview.jpg"),
  },
  {
    id: 2,
    src: "/assets/videos/krygina/2.webm",
    poster: require("./images/krygina/6-2-video-preview.jpg"),
  },
];

export default kryginaVideos;
